var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-warp",style:({
    display: 'grid',
    'grid-template-columns': `repeat(${_vm.count}, ${100 / _vm.count}%)`,
  })},_vm._l((_vm.list),function(r){return _c('el-tag',{key:r,staticClass:"tag",attrs:{"type":"warning","effect":"plain","size":"medium"}},[_vm._v(" "+_vm._s(r)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }